<template>
  <div class="warp">
    <header-title :title="title">
      <template #right>
        <andon-badge
          style="margin-right: 10px"
          :region-code="regionCode"
        ></andon-badge>
        <span @click="init">
          <RedoOutlined />
        </span>
      </template>
    </header-title>
    <nav-bar
      :is-signal-type="isSignalType"
      :region-code="regionCode"
      :current="1"
    ></nav-bar>

    <div class="warp-body">
      <div class="table-box" id="aTableRef">
        <a-table
          :columns="columns"
          :row-key="(record) => record.id"
          :data-source="tagList"
          :loading="tableLoading"
          :scroll="{ x: isMobile ? 1200 : 'auto', y: tableYHeight }"
          size="small"
        >
          <template #bodyCell="{ column, record, index }">
            <template v-if="column.dataIndex === 'action'">
              <a-button
                type="primary"
                size="small"
                :disabled="record.disabledConfirm"
                @click="register(record, index)"
              >
                Confirm
              </a-button>
            </template>
          </template>
        </a-table>
      </div>
    </div>
    <a-modal
      v-model:visible="selectObjIdModal"
      title="Please select Object ID"
      @cancel="selectObjIdModal = false"
      @ok="objOk"
    >
      <a-select
        v-model:value="curObjectId"
        style="width: 100%"
        placeholder="Please select Object ID"
      >
        <a-select-option :value="item" v-for="item in objectIds" :key="item">
          {{ item }}
        </a-select-option>
      </a-select>
    </a-modal>
  </div>
</template>

<script>
  import HeaderTitle from '@/layout/header-title'
  import AndonBadge from '@/components/andon-badge'
  import NavBar from './nav-bar'
  import { RedoOutlined } from '@ant-design/icons-vue'
  import { getRegionByGroup } from '@/api/workStation'
  import {
    getEmptyTag,
    updateUwbBinding,
    writeLcTag,
    checkObjectId,
  } from '@/api/fifo'
  import { mapGetters } from 'vuex'
  import { throttle, parseTime } from '@/utils'
  import { message, Modal } from 'ant-design-vue'

  export default {
    components: {
      HeaderTitle,
      AndonBadge,
      NavBar,
      RedoOutlined,
    },

    data() {
      return {
        regionCode: this.$route.params.regionCode,
        title: 'Stock Registration (' + this.$route.params.regionCode + ')',
        tagList: [],
        curObjectId: '',
        loading: false,
        tableLoading: false,
        isSignalType: false,
        tableYHeight: 300,
        objectIds: [],
        selectObjIdModal: false,
        curRow: null,
        curIndex: 0,
        columns: [
          {
            title: 'No',
            dataIndex: 'no',
            key: 'no',
            customRender({ index }) {
              return index + 1
            },
            width: '8%',
          },
          {
            title: 'Tag ID',
            dataIndex: 'tagId',
            width: '18%',
          },
          {
            title: 'Mat. ID',
            dataIndex: 'matId',
            width: '10%',
          },
          {
            title: 'Mat. Description',
            dataIndex: 'matGroup',
            width: '30%',
          },
          {
            title: 'Quantity',
            dataIndex: 'qty',
            width: '10%',
          },
          {
            title: 'Move In Time',
            dataIndex: 'moveInTime',
            width: '13%',
            customRender({ text }) {
              return parseTime(text, '{m}/{d} {h}:{i}')
            },
          },
          {
            title: 'Action',
            dataIndex: 'action',
            width: '10%',
          },
        ],
      }
    },
    created() {
      this.init()
    },

    computed: {
      isMobile() {
        return this.device === 'mobile'
      },

      ...mapGetters({
        device: 'settings/device',
        curNetGroupId: 'user/currentNetGroup',
      }),
    },
    mounted() {
      setTimeout(this.setTableScrollH, 2000)
      window.addEventListener('resize', throttle(this.setTableScrollH, 500))
    },
    methods: {
      async init() {
        try {
          this.getTagList()
          this.getSignalType()
        } catch (e) {
          console.log(e)
        }
      },

      setTableScrollH() {
        let top = 88
        const obj = document.getElementById('aTableRef')
        if (obj) {
          top = obj.getBoundingClientRect().top
        }
        const wH = window.innerHeight
        this.tableYHeight = wH - (top + 80)
      },
      // 判断是否是 signalType ,用来判断是否要到scan页面
      async getSignalType() {
        try {
          const { body } = await getRegionByGroup({
            netGroupId: this.curNetGroupId,
          })
          if (!body.length) return
          const f = body.find((item) => item.regionCode == this.regionCode)
          this.isSignalType = ['RFID', 'BARCODE'].includes(f.signalType)
          return Promise.resolve()
        } catch (e) {
          return Promise.reject(e)
        }
      },

      async getTagList() {
        this.tableLoading = true
        try {
          const d = await getEmptyTag(this.regionCode)
          this.tagList = d.map((item) => {
            item.disabledConfirm = false
            return item
          })
          this.tableLoading = false
        } catch (e) {
          this.tableLoading = false
        }
      },
      _updateUwbBinding(tagId, objectId, callback) {
        updateUwbBinding(tagId, objectId).then((res) => {
          callback(res)
        })
      },
      _writeLCTag(item, n) {
        let _this = this
        const loading = message.loading('loading..', 0)
        writeLcTag(this.regionCode, item.tagId).then(function (resp) {
          loading()
          _this.tagList[n].disabledConfirm = false
          if (resp.status === 1) {
            message.success('Success!')
            setTimeout(_this.getTagList, 3000)
            _this.selectObjIdModal = false
          } else {
            Modal.error({
              title: 'Error',
              content: resp.msg,
            })
          }
        })
      },
      async register(item, n) {
        let _this = this
        this.tagList[n].disabledConfirm = true
        this.curRow = item
        this.curIndex = n
        checkObjectId(item.tagId, this.regionCode).then((res) => {
          if (res.body && res.body.length > 1) {
            _this.objectIds = res.body
            _this.selectObjIdModal = true
          } else if (res.body && res.body.length === 1) {
            _this._updateUwbBinding(item.tagId, res.body[0], function () {
              _this._writeLCTag(item, n)
            })
          } else {
            _this._writeLCTag(item, n)
          }
        })
      },
      objOk() {
        this._updateUwbBinding(this.curRow.tagId, this.curObjectId, () => {
          this._writeLCTag(this.curRow, this.curIndex)
        })
      },
    },
  }
</script>

<style lang="less" scoped>
  @import './fifo.less';

  .warp-body {
    height: calc(100vh - 34px - 44px - 44px);
    overflow: auto;
    padding: 15px;
  }
</style>
